/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Nav } from "../components";
import { mq } from "../components/responsive";

const WithNav = (Component) => {
  return (
    <div
      css={{
        paddingTop: "8rem",
        [mq.md]: {
          paddingTop: "10rem",
        },
      }}
    >
      <Nav />
      <Component />
    </div>
  );
};

export default WithNav;
